<template>      
    <div>
        <div class="container center">
            <div class="row">
                <div class="col s9">
                    <span class="font-xxlarge">{{ bodyFat | NaN }}%</span><small> of body fat</small>
                </div>
                <div class="col s3">
                    <router-link :to="{ name:'BodyLog' }"><i class="material-icons medium">insert_chart</i></router-link>
                </div>
            </div>
        </div>
        <div class="container">
          <div class="input-field">
              <input id="weight" type="number" step="0.1" min="0" class="validate" v-model.number.lazy="weight">
              <span class="helper-text" data-error="wrong">Weight in kg</span>
          </div>
          <div class="input-field">
              <input id="waist" type="number" step="0.1" min="0" class="validate" v-model.number.lazy="waist">
              <span class="helper-text" data-error="wrong" >Waist in cm</span>
          </div>
          <div class="row">
                  <button class="btn waves-effect waves-light right" v-on:click="log()">Log</button>
          </div>
        </div>
      </div>

    
</template>
<script>
import api from '@/api'
import M from 'materialize-css'
export default {
  name: 'bodyShape',
  props: {
    'user': Object,
    'callback': Function
  },
  data: function () {
    return {
      weight: undefined,
      waist: undefined,
      name: undefined,
      gender: undefined
    }
  },
  created () {
    this.weight = this.user.athlete.weight
    this.waist = this.user.athlete.waist
    this.name = this.user.athlete.name
    this.gender = this.user.athlete.gender
  },
  watch: {
    waist: function (val) {
      this.user.athlete.waist = (val === '' ? undefined : val)
      api.update(this.user)
    },
    weight: function (val) {
      this.user.athlete.weight = (val === '' ? undefined : val)
      api.update(this.user)
    }
  },
  methods: {
    log: function () {
      this.user.addBodyChange({
        weight: this.weight,
        waist: this.waist
      })
      this.user.athlete.weight = this.weight
      this.user.athlete.waist = this.waist
      api.update(this.user)
      if (this.callback) this.callback(this.user)
      M.toast({html: 'Weight and waist logged!'})
    }
  },
  computed: {
    bodyFat: function () {
      this.gender = this.gender // to maintain reactivity
      return this.user.bodyFat(this.weight, this.waist)
    }
  },
  filters: {
    NaN: function (value) {
      if (isNaN(value)) {
        return '- '
      } else {
        return value
      }
    }
  }

}
</script>

<style>
.font-xxlarge {
    font-size: 300%;
    padding-top: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/athlete/BodyShape.vue